import React, {useContext, useMemo} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {useIntl} from 'react-intl';
import I18nMessage from '../../components/I18nMessage';
import LoadingBar from '../../components/loadingBar';
import {ThemeContext} from '../../apiContexts';
import {ThemedTableWrapper} from '../../components/dataTable/style';
import {computeColumnWidths, toProportionalPercentages} from '../../helpers/columnWidth';

const HEADERS = [
    {title: 'accumulatorColRegistered', field: 'registeredAt'},
    {title: 'accumulatorColField', field: 'field'},
    {title: 'accumulatorColPrevious', field: 'previous'},
    {title: 'accumulatorColEditedAt', field: 'editedAt'},
    {title: 'accumulatorColNew', field: 'edited'},
    {title: 'accumulatorColUser', field: 'user'},
    {title: 'accumulatorColEmail', field: 'email'},
];

// Edicoes do odometro de um IMEI, mais recentes primeiro. O servidor entrega no maximo 100 linhas; a tela mostra 10 por
// pagina, como as demais tabelas.
const AccumulatorHistoryTable = ({loading, error, rows}) => {
    const intl = useIntl();
    const theme = useContext(ThemeContext);

    const columnWidths = useMemo(() => computeColumnWidths(HEADERS.map((item) => ({
        key: item.field,
        title: intl.formatMessage({id: item.title}),
        values: rows.map((row) => row[item.field]),
    }))), [rows, intl]);
    const columnPercentages = toProportionalPercentages(columnWidths);
    const tableMinWidth = HEADERS.reduce((sum, item) => sum + (columnWidths[item.field] || 0), 0);

    if (loading) {
        return <LoadingBar />;
    }

    if (error) {
        return <p className="text-center my-4"><I18nMessage id="accumulatorHistoryError" /></p>;
    }

    const options = {
        noDataText: intl.formatMessage({id: 'accumulatorNeverEdited'}),
        sizePerPageList: [{text: '10', value: 10}, {text: '50', value: 50}],
        sizePerPage: 10,
        prePage: intl.formatMessage({id: 'sharedPrev'}),
        nextPage: intl.formatMessage({id: 'sharedNext'}),
        firstPage: intl.formatMessage({id: 'sharedFirst'}),
        lastPage: intl.formatMessage({id: 'sharedLast'}),
    };

    return (
        <ThemedTableWrapper theme={theme}>
            <BootstrapTable
                options={options}
                data={rows}
                keyField="key"
                tableStyle={{'--table-min-width': `${tableMinWidth}px`}}
                striped
                hover
                pagination
            >
                {HEADERS.map((item) => (
                    <TableHeaderColumn
                        key={item.field}
                        dataField={item.field}
                        width={columnPercentages[item.field]}>
                        <I18nMessage id={item.title} />
                    </TableHeaderColumn>
                ))}
            </BootstrapTable>
        </ThemedTableWrapper>
    );
};

export default AccumulatorHistoryTable;
